import React, { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./Wishlist.css";

const Wishlist = () => {
  const { wishlist, addToCart, removeFromWishlist } = useContext(CartContext);
  const navigate = useNavigate();

  const [message, setMessage] = useState(""); // ✅ NEW

  return (
    <>
      {/* ✅ AMAZON STYLE SUCCESS BAR */}
      {message && (
        <div className="toast">
          <FaCheckCircle className="toast-icon" />
          <span>{message}</span>
          <div className="progress-bar"></div>
        </div>
      )}

      <div className="wishlist">
        <h2>My Wishlist ❤️</h2>

        {wishlist.length === 0 ? (
          <div className="empty-state">
            <p className="empty">Your wishlist is empty 😢</p>

            {/* CTA BUTTON */}
            <button
              className="explore-btn"
              onClick={() => navigate("/")}
            >
              Explore Collection
            </button>
          </div>
        ) : (
          <div className="wishlist-grid">
            {wishlist.map((item) => (
              <div className="wishlist-card" key={item.id}>
                
                {/* IMAGE */}
                <img
                  src={item.images?.[0] || item.image}
                  alt={item.name}
                  onClick={() => navigate(`/product/${item.id}`)}
                />

                {/* CONTENT */}
                <h3>{item.name}</h3>
                <p>₹{item.price}</p>

                {/* ACTION BUTTONS */}
                <div className="wishlist-actions">
                  
                  {/* ✅ ADD TO CART */}
                  <button
                    onClick={() => {
                      addToCart(item);
                      removeFromWishlist(item.id);

                      setMessage("Item moved to Cart ✅"); // ✅ NEW
                      setTimeout(() => setMessage(""), 2500);
                    }}
                  >
                    Add to Cart
                  </button>

                  {/* ✅ REMOVE */}
                  <button
                    className="remove-btn"
                    onClick={() => {
                      removeFromWishlist(item.id);

                      setMessage("Removed from Wishlist ❌"); // ✅ NEW
                      setTimeout(() => setMessage(""), 2500);
                    }}
                  >
                    Remove ❌
                  </button>

                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Wishlist;